import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Loader2, Pencil } from "lucide-react";

const API = "/api";

export const NewsManager = () => {
  const [items, setItems] = useState(null);
  const [form, setForm] = useState({ title: "", currency: "USD", impact: "high", time_iso: "" });
  const [loading, setLoading] = useState(false);

  const headers = () => ({ Authorization: `Bearer ${localStorage.getItem("atr_token") || sessionStorage.getItem("atr_admin_token") || ""}` });

  const load = useCallback(async () => {
    const { data } = await axios.get(`${API}/admin/news`, { headers: headers() });
    setItems(data.items);
  }, []);

  useEffect(() => { load().catch(() => {}); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/admin/news`, { ...form, time_iso: new Date(form.time_iso).toISOString() }, { headers: headers() });
      toast.success("Event berita ditambahkan");
      setForm({ title: "", currency: "USD", impact: "high", time_iso: "" });
      load();
    } catch {
      toast.error("Gagal menambah event");
    } finally {
      setLoading(false);
    }
  };

  const remove = async (id) => {
    await axios.delete(`${API}/admin/news/${id}`, { headers: headers() });
    load();
  };

  return (
    <div className="mt-12" data-testid="news-manager">
      <h2 className="font-display text-xl font-bold text-white">Kalender Berita (News Filter)</h2>
      <p className="mt-1 font-mono text-xs text-mute-dim">
        &gt; event HIGH impact memblokir entry ±15 menit untuk simbol terkait mata uangnya
      </p>

      <form onSubmit={add} className="mt-5 flex flex-wrap items-end gap-2 border border-white/10 bg-ink-surface p-4">
        <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required
          placeholder="judul event (mis. NFP AS)" data-testid="news-title-input"
          className="h-10 flex-1 min-w-[180px] border border-white/15 bg-ink px-3 font-mono text-xs text-white outline-none focus:border-buy/60" />
        <select value={form.currency} onChange={(e) => setForm({ ...form, currency: e.target.value })} data-testid="news-currency-select"
          className="h-10 border border-white/15 bg-ink px-2 font-mono text-xs text-white">
          {["USD", "EUR", "GBP", "JPY"].map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <select value={form.impact} onChange={(e) => setForm({ ...form, impact: e.target.value })} data-testid="news-impact-select"
          className="h-10 border border-white/15 bg-ink px-2 font-mono text-xs text-white">
          {[["high", "HIGH"], ["medium", "MEDIUM"], ["low", "LOW"]].map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <input type="datetime-local" value={form.time_iso} onChange={(e) => setForm({ ...form, time_iso: e.target.value })} required
          data-testid="news-time-input"
          className="h-10 border border-white/15 bg-ink px-2 font-mono text-xs text-white outline-none focus:border-buy/60" />
        <button type="submit" disabled={loading} data-testid="news-add-button"
          className="flex h-10 items-center gap-2 border border-buy bg-buy/10 px-4 font-mono text-xs font-bold text-buy transition-colors hover:bg-buy hover:text-ink disabled:opacity-60">
          {loading ? <Loader2 size={13} className="animate-spin" /> : <Plus size={13} />} TAMBAH
        </button>
      </form>

      <div className="mt-4 border border-white/10" data-testid="news-list">
        {!items || items.length === 0 ? (
          <p className="px-4 py-6 text-center font-mono text-xs text-mute-dim">belum ada event terjadwal</p>
        ) : (
          items.map((ev) => (
            <div key={ev.id} className="flex flex-wrap items-center justify-between gap-2 border-b border-white/5 px-4 py-3 last:border-0">
              <div className="font-mono text-xs">
                <span className={`mr-2 border px-1.5 py-0.5 text-[9px] font-bold ${ev.impact === "high" ? "border-sell/40 text-sell" : "border-warn/40 text-warn"}`}>
                  {ev.impact.toUpperCase()}
                </span>
                <span className="font-bold text-white">{ev.currency}</span>
                <span className="ml-2 text-mute">{ev.title}</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-mono text-[10px] text-mute-dim">{new Date(ev.time_iso).toLocaleString("id-ID")}</span>
                {ev.actual && <span className="font-mono text-[10px] font-bold text-buy">A: {ev.actual}</span>}
                <button
                  onClick={async () => {
                    const v = window.prompt(`Nilai ACTUAL untuk "${ev.title}":`, ev.actual || "");
                    if (v == null) return;
                    await axios.patch(`${API}/admin/news/${ev.id}`, { actual: v }, { headers: headers() });
                    load();
                  }}
                  data-testid={`news-actual-${ev.id.slice(0, 8)}`}
                  className="text-mute-dim transition-colors hover:text-buy" title="isi nilai actual">
                  <Pencil size={13} />
                </button>
                <button onClick={() => remove(ev.id)} data-testid={`news-delete-${ev.id.slice(0, 8)}`}
                  className="text-mute-dim transition-colors hover:text-sell">
                  <Trash2 size={13} />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
